import React, { Component } from 'react';
import resources from '../../resources';
import TextSection from '../BaseComponents/TextSection';
import TextSection2 from '../BaseComponents/TextSection2';
import TextSectionWithStructuredBullets from '../BaseComponents/TextSectionWithStructuredBullets';
import ImageBulletedSection from '../BaseComponents/ImageBulletedSection';
import StoreManager from '../../appdata';
import languages from '../../appdata/languages';

class ManagementReportContent1 extends Component {
  render() {
    
    const lang = StoreManager.appState.thisApp.state.currentLanguage;
    const content = languages[lang].ManagementReportContent1;
        const {isMobile} = StoreManager.appState.thisApp.state
    
    return (
      <div>
          <h2 style={{  fontFamily: 'Inter28-SemiBold', fontSize: isMobile ? 24 : 36, fontWeight: 500, marginBottom: 24 }}>
            {content.title}
          </h2>
          <TextSection title={content.section1Title} paragraphs={content.section1TextArray} />
          <img
                    src={lang == 'vi'? resources.images.ManagementReport1Image1_vi: resources.images.ManagementReport1Image1}
                    style={{width: '100%',
                      borderRadius: 8,
                      objectFit: 'cover'}}
                  />
        <TextSection2 title={content.section2Title} paragraphs={content.section2TextArray} padding={0}/>
        <ImageBulletedSection items={content.section2TextArray2} />
        <TextSection2 title={content.section3Title} paragraphs={content.section3TextArray} padding={0}/>
        <TextSection2 title={content.section4Title} paragraphs={content.section4TextArray} padding={0}/>
        <TextSection2 title={content.section5Title} paragraphs={content.section5TextArray} padding={0}/>
        <TextSection2 title={content.section6Title} paragraphs={content.section6TextArray} padding={0}/>
        <TextSection2 title={content.section7Title} paragraphs={content.section7TextArray} padding={0}/>
        <TextSection2 title={content.section8Title} paragraphs={content.section8TextArray} padding={0}/>
        <TextSection2 title={content.section9Title} paragraphs={content.section9TextArray} padding={0}/>
        <TextSection2 title={content.section10Title} paragraphs={content.section10TextArray} padding={0}/>

        <TextSection title={content.section11Title} paragraphs={content.section11TextArray} />
        <img
                    src={lang == 'vi'? resources.images.ManagementReport1Image3_vi:resources.images.ManagementReport1Image3}
                    style={{width: '100%',
                      borderRadius: 8,
                      objectFit: 'cover'}}
                  />
        {/* <TextSection2 title={content.section12Title} paragraphs={content.section12TextArray} padding={0}/> */}
        <TextSection title={content.section13Title} paragraphs={content.section13TextArray} padding={0}/>
        <img
                    src={lang == 'vi'? resources.images.ManagementReport1Image4_vi:resources.images.ManagementReport1Image4}
                    style={{width: '100%',
                      borderRadius: 8,
                      objectFit: 'cover'}}
                  />

        <TextSection2 title={content.section14Title} paragraphs={content.section14TextArray} padding={0}/>

        <TextSection title={content.section15Title} paragraphs={content.section15TextArray} padding={0}/>
        <img
                    src={lang == 'vi'? resources.images.ManagementReport1Image5_vi:resources.images.ManagementReport1Image5}
                    style={{width: '100%',
                      borderRadius: 8,
                      objectFit: 'cover'}}
                  />
        <TextSection2 title={content.section16Title} paragraphs={content.section16TextArray} padding={0}/>



       
      </div>
    );
  }
}

export default ManagementReportContent1;
